export class HttpError extends Error {
	public readonly isHttpError = true as const;
	public readonly status: number;

	constructor(status: number, statusText?: string) {
		super(statusText || `HTTP ${status}`);
		this.status = status;
		this.name = "HttpError";
		Object.setPrototypeOf(this, HttpError.prototype);
	}
}

export const isHttpError = (error: unknown): error is HttpError =>
	!!error &&
	typeof error === "object" &&
	(error as { isHttpError?: unknown }).isHttpError === true;
